<template>
  <div>
    <round-chart
      v-if="!isEmpty"
      class="graph"
      :class="{'small': small}"
      :options="options"
      :nostyle="nostyle"
      :nocolors="nocolors"
      :chartData="chartData"
    ></round-chart>
    <div v-else-if="loading" class="flex column middle center">
      <div class="loading">
        <content-loading>
          <fake-line height="140"></fake-line>
        </content-loading>
      </div>
    </div>
    <div v-else class="flex column middle center txt-center empty-graph">
      <div>
        <i class="fas fa-chart-pie"></i>
      </div>
      <p class="margin-top-l">sem informações para gerar o gráfico! </p>
    </div>
  </div>
</template>

<script>
import RoundChart from "@/components/charts/RoundChart";

export default {
  name: "round-graph",
  props: ["options", "chartData", "nostyle", "nocolors", "small","loading"],
  components: {
    RoundChart
  },
  data() {
    return {}
  },
  mounted() {
  },
  computed: {
    isEmpty() {
      return !this.chartData || (this.chartData && this.chartData.labels && this.chartData.labels.length === 0) 
    }
  }
};
</script>


<style scoped>
.empty-graph {
  padding: 30px;
  i {
    font-size: 120px;
  }
}

.graph {
    max-width: 100%;
    max-height: 300px;
  }

.small {
  max-height: 200px;
  width: 300px;
  display: flex;
  flex:1;
  /* max-width: 120px; */
}

.loading {
  margin-top: 30px;
  min-width: 130px;
  width: 130px;
}
</style>